module.exports = __webpack_public_path__ + "img/ai_new.e7513ad1.png";